import { useGetGlucoseValueAsPercentage } from "./useGetGlucoseValueAsPercentage"

export function useGlucoseValueAsPercentage(glucoseValue: number): [number, boolean] {
  const getGlucoseValueAsPercentage = useGetGlucoseValueAsPercentage()
  return getGlucoseValueAsPercentage(glucoseValue)
}
